import store from '../../../../store';
export default function checkIfCanUpdate() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('user_account_roles_update_company') || scopes.includes('user_account_roles_update_all')) {
    exists = true;
  }
  return exists;
}
